import type { GraphQLClient } from 'graphql-request';
import type { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Array: { input: any; output: any; }
  JsonArgument: { input: any; output: any; }
};

export type CustomerLogosQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type CustomerLogosQuery = { entries?: { data?: Array<{ id: string, title: string, link: string, logo?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, offer_topics?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | {} | null> | null } | null };

export type CustomerLogosAndTermsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
  filterLocale?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type CustomerLogosAndTermsQuery = { entries?: { data?: Array<{ id: string, title: string, link: string, logo?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, offer_topics?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | {} | null> | null } | null, terms?: { data?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null };

export type EntryQueryVariables = Exact<{
  uri?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntryQuery = { entry?: { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, description?: string | null, date?: string | null, time: string, time_until: string, event_link?: string | null, location?: string | null, online?: boolean | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, event_type?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null, event_organizer?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, company_link?: string | null, company_name?: string | null, created_at?: string | null, in_join_created_at?: string | null, description?: string | null, homeoffice?: boolean | null, link: string, location?: string | null, pensum?: string | null, permalink?: string | null, from_now?: boolean | null, start?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, content?: string | null, date?: string | null, image_alt?: string | null, permalink?: string | null, summary?: string | null, published_at?: string | null, news_image?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, headline?: string | null, lead?: string | null, hero_link?: string | null, hero_link_text?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null, illustration?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, content_elements?: Array<{ type: string, section_image?: string | null, section_subtopic?: string | null, call_to_action?: string | null, headline?: string | null, lead?: string | null, link?: string | null, link_text?: string | null, paragraph?: string | null, paragraph_content?: string | null, section_video?: string | null, subtopic?: string | null, video_embedded?: string | null, paragraph_type?: { value?: string | null } | null, image?: { url?: string | null, id: string, extension: string, permalink?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, image_handling?: { label?: string | null, value?: string | null } | null, layout?: { label?: string | null, value?: string | null } | null } | { type: string, title?: string | null } | { type: string } | { type: string } | { type: string } | { type: string } | { type: string } | { type: string, newsletter_title?: string | null, newsletter_text?: string | null, newsletter?: string | null, newsletter_button_text?: string | null, newsletter_from?: { handle: string, honeypot?: string | null, rules?: any | null, title: string } | null } | { type: string, preselected_offer_topic?: { id: string, title: string, slug: string } | {} | null } | {} | null> | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null } | { url?: string | null, id: string, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string }, seo?: { title: string, description?: string | null, canonical_url?: string | null, change_frequency?: string | null, compiled_title?: string | null, home_url?: string | null, humans_txt?: string | null, next_url?: string | null, og_title?: string | null, prev_url?: string | null, priority?: string | null, site_name?: string | null, site_name_position?: string | null, site_name_separator?: string | null, twitter_card?: string | null, twitter_handle?: string | null, is_og_glide_enabled?: string | null, is_twitter_glide_enabled?: string | null, google_verification?: string | null, bing_verification?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, site?: { handle?: string | null, direction?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null, alternate_locales?: Array<{ url?: string | null, site?: { direction?: string | null, handle?: string | null, lang?: string | null, locale?: string | null, name?: string | null, permalink?: string | null, short_locale?: string | null, url?: string | null } | null } | null> | null, robots?: Array<{ value?: string | null } | null> | null } | null } | null };

export type EntryHeroQueryVariables = Exact<{
  uri?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntryHeroQuery = { entry?: { url?: string | null, id: string, title: string, slug: string } | { url?: string | null, id: string, title: string, slug: string } | { url?: string | null, id: string, title: string, slug: string } | { url?: string | null, id: string, title: string, slug: string } | { url?: string | null, id: string, title: string, slug: string } | { headline?: string | null, lead?: string | null, hero_link?: string | null, hero_link_text?: string | null, url?: string | null, id: string, title: string, slug: string, illustration?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | { url?: string | null, id: string, title: string, slug: string } | { url?: string | null, id: string, title: string, slug: string } | null };

export type EventsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type EventsQuery = { entries?: { current_page: number, last_page: number, total: number, per_page: number, data?: Array<{ id: string, slug: string, url?: string | null, title: string, description?: string | null, date?: string | null, time: string, time_until: string, event_link?: string | null, location?: string | null, online?: boolean | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, event_type?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null, event_organizer?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null } | {} | null> | null } | null };

export type EventsAndTermsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
  filterLocale?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type EventsAndTermsQuery = { entries?: { current_page: number, last_page: number, total: number, per_page: number, data?: Array<{ id: string, slug: string, url?: string | null, title: string, description?: string | null, date?: string | null, time: string, time_until: string, event_link?: string | null, location?: string | null, online?: boolean | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, event_type?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null, event_organizer?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null } | {} | null> | null } | null, event_types?: { data?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null, event_organizers?: Array<{ id: string, slug: string, title: string } | {} | null> | null };

export type JobsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type JobsQuery = { entries?: { current_page: number, last_page: number, total: number, per_page: number, data?: Array<{ id: string, slug: string, url?: string | null, title: string, company_link?: string | null, company_name?: string | null, created_at?: string | null, in_join_created_at?: string | null, description?: string | null, homeoffice?: boolean | null, link: string, location?: string | null, pensum?: string | null, permalink?: string | null, from_now?: boolean | null, start?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | {} | null> | null } | null };

export type JobsAndTermsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
  filterLocale?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type JobsAndTermsQuery = { entries?: { current_page: number, last_page: number, total: number, per_page: number, data?: Array<{ id: string, slug: string, url?: string | null, title: string, company_link?: string | null, company_name?: string | null, created_at?: string | null, in_join_created_at?: string | null, description?: string | null, homeoffice?: boolean | null, link: string, location?: string | null, pensum?: string | null, permalink?: string | null, from_now?: boolean | null, start?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | {} | null> | null } | null, terms?: { data?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null };

export type NavigationAndGlobalsQueryVariables = Exact<{
  site?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavigationAndGlobalsQuery = { nav?: { title: string, tree?: Array<{ page?: { id: string, title?: string | null, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | null, children?: Array<{ page?: { id: string, title?: string | null, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | null } | null> | null } | null> | null } | null, home_buttons?: { handle: string, entries?: Array<{ title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | null> | null } | {} | null, header_content?: { search?: string | null, handle: string, logo?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, about?: { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | { title: string, url?: string | null, slug: string } | null, offersearch?: { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | { url?: string | null, slug: string, title: string } | null } | {} | null, footer_content?: { address?: string | null, phone?: string | null, email?: string | null, handle: string, logo?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, privacy?: { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | null, imprint?: { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | { id: string, url?: string | null, title: string } | null } | {} | null, translations?: { handle: string, toggle_navigation?: string | null, back_link_text?: string | null, all_offer_topics?: string | null, all_professional_fields?: string | null, and_homeoffice?: string | null, company_link?: string | null, company_name?: string | null, job_contact_email?: string | null, continue_reading?: string | null, description?: string | null, description_placeholder?: string | null, filter_empty?: string | null, from_now?: string | null, homeoffice?: string | null, is_required?: string | null, job_advert_description?: string | null, job_advert_published_at?: string | null, job_form_button_text?: string | null, job_form_contact_subtitle?: string | null, job_form_subtitle?: string | null, job_form_text?: string | null, job_form_title?: string | null, job_title?: string | null, link?: string | null, link_error?: string | null, link_is_copied?: string | null, link_to_share?: string | null, location?: string | null, newsletter_button_text?: string | null, newsletter_email?: string | null, newsletter_success_message?: string | null, newsletter_text?: string | null, newsletter_title?: string | null, pensum?: string | null, professional_fields?: string | null, professional_fields_placeholder?: string | null, published_at?: string | null, shared_content?: string | null, social_media_links_title?: string | null, start?: string | null, start_from_now?: string | null, start_error?: string | null, time_start_error?: string | null, job_success_message?: string | null, submit_error?: string | null, to_home?: string | null, to_job_advert?: string | null, to_main_content?: string | null, to_main_navigation?: string | null, to_page_ending?: string | null, whole_amount?: string | null, event_title?: string | null, event_description?: string | null, event_type?: string | null, event_link?: string | null, event_image?: string | null, event_location?: string | null, event_date?: string | null, event_time?: string | null, event_time_until?: string | null, event_all_types?: string | null, event_online?: string | null, event_organizer?: string | null, event_info_and_registration?: string | null, event_form_title?: string | null, event_form_text?: string | null, event_form_subtitle?: string | null, event_form_contact_subtitle?: string | null, event_form_button_text?: string | null, event_contact_email?: string | null, event_upload_image_button?: string | null, event_success_message?: string | null, hrs?: string | null, you_might_also_be_interested_in?: string | null, logo_overlay?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | {} | null, forms?: { job_setup?: { handle: string, honeypot?: string | null, rules?: any | null, title: string, fields?: Array<{ config?: any | null, display: string, handle: string, instructions?: string | null, type: string, width?: number | null } | null> | null } | null, newsletter?: { handle: string, honeypot?: string | null, rules?: any | null, title: string, fields?: Array<{ config?: any | null, display: string, handle: string, instructions?: string | null, type: string, width?: number | null } | null> | null } | null, event_setup?: { handle: string, honeypot?: string | null, rules?: any | null, title: string, fields?: Array<{ config?: any | null, display: string, handle: string, instructions?: string | null, type: string, width?: number | null } | null> | null } | null } | {} | null, offer_selection?: { heading?: string | null, subtitle?: string | null, question_1?: string | null, question_2?: string | null, question_3?: string | null, contact_person?: string | null, discover_more?: string | null, filter?: string | null, handle: string, key_data?: string | null, overlay?: string | null, result_singular?: string | null, results?: string | null, partner_dropdown?: string | null, site: { handle: string, locale: string, name: string, short_locale: string, url: string } } | {} | null, error_404?: { text?: string | null, back_to_home?: string | null, title: string } | {} | null, error_500?: { text?: string | null, back_to_home?: string | null, title: string } | {} | null, error_503?: { text?: string | null, title: string } | {} | null };

export type NewsArticlesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type NewsArticlesQuery = { entries?: { current_page: number, last_page: number, total: number, per_page: number, data?: Array<{ id: string, slug: string, url?: string | null, title: string, summary?: string | null, image_alt?: string | null, content?: string | null, published_at?: string | null, news_image?: string | null } | {} | null> | null } | null };

export type NewsArticlesTeaserQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type NewsArticlesTeaserQuery = { newest?: { data?: Array<{ id: string, slug: string, url?: string | null, title: string, summary?: string | null, image_alt?: string | null, content?: string | null, published_at?: string | null, news_image?: string | null } | {} | null> | null } | null, random?: { data?: Array<{ id: string, slug: string, url?: string | null, title: string, summary?: string | null, image_alt?: string | null, content?: string | null, published_at?: string | null, news_image?: string | null } | {} | null> | null } | null };

export type OfferTermsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type OfferTermsQuery = { company_phases?: { data?: Array<{ id: string, slug: string, title: string, icon?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null, offer_topics?: { data?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null, offer_language?: { data?: Array<{ id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null };

export type OffersQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type OffersQuery = { entries?: { current_page: number, last_page: number, total: number, per_page: number, data?: Array<{ id: string, email?: string | null, contact_person?: string | null, contact_person_2?: string | null, date?: string | null, description?: string | null, email_2?: string | null, phone?: string | null, phone_2?: string | null, short_description?: string | null, slug: string, title: string, kontaktperson?: string | null, links?: Array<{ link?: string | null, link_text?: string | null } | null> | null, partner_logo?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, partner?: { id: string, slug: string, title: string, logo?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | {} | null, key_data?: Array<{ text?: string | null } | null> | null, company_phases?: Array<{ title: string, url?: string | null, id: string, slug: string, taxonomy: { title: string, handle: string } } | { title: string, url?: string | null, id: string, slug: string, taxonomy: { title: string, handle: string } } | { title: string, url?: string | null, id: string, slug: string, taxonomy: { title: string, handle: string } } | { title: string, url?: string | null, id: string, slug: string, taxonomy: { title: string, handle: string } } | { title: string, url?: string | null, id: string, slug: string, taxonomy: { title: string, handle: string } } | { title: string, url?: string | null, id: string, slug: string, taxonomy: { title: string, handle: string } } | null> | null, offer_topics?: Array<{ slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | null> | null, offer_language?: Array<{ slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | { slug: string, id: string, title: string } | null> | null } | {} | null> | null } | null };

export type TermsQueryVariables = Exact<{
  taxonomy?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JsonArgument']['input']>;
}>;


export type TermsQuery = { terms?: { data?: Array<{ id: string, slug: string, title: string, icon?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null> | null } | null };

type ContentElements_BardText_Fragment = {};

type ContentElements_Set_ContentElements_ContentParagraph_Fragment = { type: string, section_image?: string | null, section_subtopic?: string | null, call_to_action?: string | null, headline?: string | null, lead?: string | null, link?: string | null, link_text?: string | null, paragraph?: string | null, paragraph_content?: string | null, section_video?: string | null, subtopic?: string | null, video_embedded?: string | null, paragraph_type?: { value?: string | null } | null, image?: { url?: string | null, id: string, extension: string, permalink?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, image_handling?: { label?: string | null, value?: string | null } | null, layout?: { label?: string | null, value?: string | null } | null };

type ContentElements_Set_ContentElements_CustomerLogos_Fragment = { type: string, title?: string | null };

type ContentElements_Set_ContentElements_EventSetup_Fragment = { type: string };

type ContentElements_Set_ContentElements_EventsOverview_Fragment = { type: string };

type ContentElements_Set_ContentElements_Facts_Fragment = {};

type ContentElements_Set_ContentElements_Figures_Fragment = {};

type ContentElements_Set_ContentElements_JobSetup_Fragment = { type: string };

type ContentElements_Set_ContentElements_JobsOverview_Fragment = { type: string };

type ContentElements_Set_ContentElements_NewsArticles_Fragment = { type: string };

type ContentElements_Set_ContentElements_Newsletter_Fragment = { type: string, newsletter_title?: string | null, newsletter_text?: string | null, newsletter?: string | null, newsletter_button_text?: string | null, newsletter_from?: { handle: string, honeypot?: string | null, rules?: any | null, title: string } | null };

type ContentElements_Set_ContentElements_OfferSelection_Fragment = { type: string, preselected_offer_topic?: { id: string, title: string, slug: string } | {} | null };

type ContentElements_Set_ContentElements_SuccessStory_Fragment = {};

export type ContentElementsFragment = ContentElements_BardText_Fragment | ContentElements_Set_ContentElements_ContentParagraph_Fragment | ContentElements_Set_ContentElements_CustomerLogos_Fragment | ContentElements_Set_ContentElements_EventSetup_Fragment | ContentElements_Set_ContentElements_EventsOverview_Fragment | ContentElements_Set_ContentElements_Facts_Fragment | ContentElements_Set_ContentElements_Figures_Fragment | ContentElements_Set_ContentElements_JobSetup_Fragment | ContentElements_Set_ContentElements_JobsOverview_Fragment | ContentElements_Set_ContentElements_NewsArticles_Fragment | ContentElements_Set_ContentElements_Newsletter_Fragment | ContentElements_Set_ContentElements_OfferSelection_Fragment | ContentElements_Set_ContentElements_SuccessStory_Fragment;

type Document_Asset_Documents_Fragment = { id: string, extension: string, permalink?: string | null, url?: string | null };

type Document_Asset_Images_Fragment = { url?: string | null };

export type DocumentFragment = Document_Asset_Documents_Fragment | Document_Asset_Images_Fragment;

type Asset_Asset_Documents_Fragment = { url?: string | null };

type Asset_Asset_Images_Fragment = { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null };

export type AssetFragment = Asset_Asset_Documents_Fragment | Asset_Asset_Images_Fragment;

export type BlueprintEventFragment = { id: string, slug: string, url?: string | null, title: string, description?: string | null, date?: string | null, time: string, time_until: string, event_link?: string | null, location?: string | null, online?: boolean | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, event_type?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null, event_organizer?: { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | { id: string, slug: string, title: string } | null };

export type BlueprintJobFragment = { id: string, slug: string, url?: string | null, title: string, company_link?: string | null, company_name?: string | null, created_at?: string | null, in_join_created_at?: string | null, description?: string | null, homeoffice?: boolean | null, link: string, location?: string | null, pensum?: string | null, permalink?: string | null, from_now?: boolean | null, start?: string | null, image?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null };

export type BlueprintNewsFragment = { id: string, slug: string, blueprint?: string | null, title: string, content?: string | null, date?: string | null, image_alt?: string | null, permalink?: string | null, summary?: string | null, url?: string | null, published_at?: string | null, news_image?: string | null };

export type BlueprintPageFragment = { headline?: string | null, lead?: string | null, hero_link?: string | null, hero_link_text?: string | null, illustration?: { url?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, content_elements?: Array<{ type: string, section_image?: string | null, section_subtopic?: string | null, call_to_action?: string | null, headline?: string | null, lead?: string | null, link?: string | null, link_text?: string | null, paragraph?: string | null, paragraph_content?: string | null, section_video?: string | null, subtopic?: string | null, video_embedded?: string | null, paragraph_type?: { value?: string | null } | null, image?: { url?: string | null, id: string, extension: string, permalink?: string | null } | { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | null, image_handling?: { label?: string | null, value?: string | null } | null, layout?: { label?: string | null, value?: string | null } | null } | { type: string, title?: string | null } | { type: string } | { type: string } | { type: string } | { type: string } | { type: string } | { type: string, newsletter_title?: string | null, newsletter_text?: string | null, newsletter?: string | null, newsletter_button_text?: string | null, newsletter_from?: { handle: string, honeypot?: string | null, rules?: any | null, title: string } | null } | { type: string, preselected_offer_topic?: { id: string, title: string, slug: string } | {} | null } | {} | null> | null };

export const AssetFragmentDoc = gql`
    fragment Asset on AssetInterface {
  url
  ... on Asset_Images {
    id
    alt
    permalink
    url
    extension
    is_image
    width
    height
    focus_css
    extension
    size
  }
}
    `;
export const BlueprintEventFragmentDoc = gql`
    fragment BlueprintEvent on Entry_Events_Event {
  id
  slug
  url
  title
  description
  date(format: "Y-m-d")
  time
  time_until
  event_link
  image {
    ...Asset
  }
  location
  online
  event_type {
    id
    slug
    title
  }
  event_organizer {
    id
    slug
    title
  }
}
    `;
export const BlueprintJobFragmentDoc = gql`
    fragment BlueprintJob on Entry_Jobs_Jobs {
  id
  slug
  url
  title
  image {
    ...Asset
  }
  company_link
  company_name
  created_at(format: "d.m.Y")
  in_join_created_at(format: "d.m.Y")
  description
  homeoffice
  link
  location
  pensum
  permalink
  from_now
  start
}
    `;
export const BlueprintNewsFragmentDoc = gql`
    fragment BlueprintNews on Entry_News_News {
  id
  slug
  blueprint
  title
  content
  date
  news_image: image
  image_alt
  permalink
  summary
  url
  published_at
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on AssetInterface {
  url
  ... on Asset_Documents {
    id
    extension
    permalink
  }
}
    `;
export const ContentElementsFragmentDoc = gql`
    fragment ContentElements on Sets_ContentElements {
  ... on Set_ContentElements_ContentParagraph {
    type
    paragraph_type {
      value
    }
    section_image
    section_subtopic
    call_to_action
    headline
    image {
      ...Asset
      ...Document
    }
    image_handling {
      label
      value
    }
    layout {
      label
      value
    }
    lead
    link
    link_text
    paragraph
    paragraph_content
    section_video
    subtopic
    video_embedded
  }
  ... on Set_ContentElements_NewsArticles {
    type
  }
  ... on Set_ContentElements_Newsletter {
    type
    newsletter_title
    newsletter_text
    newsletter
    newsletter_button_text
    newsletter_from {
      handle
      honeypot
      rules
      title
    }
  }
  ... on Set_ContentElements_JobSetup {
    type
  }
  ... on Set_ContentElements_EventSetup {
    type
  }
  ... on Set_ContentElements_JobsOverview {
    type
  }
  ... on Set_ContentElements_CustomerLogos {
    type
    title
  }
  ... on Set_ContentElements_OfferSelection {
    type
    preselected_offer_topic {
      ... on Term_OfferTopics_OfferTopics {
        id
        title
        slug
      }
    }
  }
  ... on Set_ContentElements_EventsOverview {
    type
  }
}
    `;
export const BlueprintPageFragmentDoc = gql`
    fragment BlueprintPage on Entry_Pages_Page {
  headline
  lead
  illustration {
    ...Asset
  }
  hero_link
  hero_link_text
  content_elements {
    ...ContentElements
  }
}
    `;
export const CustomerLogosDocument = gql`
    query CustomerLogos($sort: String = "created_at desc", $filter: JsonArgument) {
  entries(collection: "customer_logos", sort: [$sort], filter: $filter) {
    data {
      ... on Entry_CustomerLogos_CustomerLogo {
        id
        title
        link
        logo {
          ...Asset
        }
        offer_topics {
          id
          slug
          title
        }
      }
    }
  }
}
    ${AssetFragmentDoc}`;
export const CustomerLogosAndTermsDocument = gql`
    query CustomerLogosAndTerms($sort: String = "created_at desc", $filter: JsonArgument, $filterLocale: JsonArgument) {
  entries(collection: "customer_logos", sort: [$sort], filter: $filter) {
    data {
      ... on Entry_CustomerLogos_CustomerLogo {
        id
        title
        link
        logo {
          ...Asset
        }
        offer_topics {
          id
          slug
          title
        }
      }
    }
  }
  terms(taxonomy: "offer_topics", sort: "index asc", filter: $filterLocale) {
    data {
      id
      slug
      title
    }
  }
}
    ${AssetFragmentDoc}`;
export const EntryDocument = gql`
    query Entry($uri: String, $site: String) {
  entry(uri: $uri, site: $site) {
    url
    id
    title
    slug
    locale
    collection {
      handle
    }
    blueprint
    ...BlueprintPage
    ...BlueprintNews
    ...BlueprintJob
    ...BlueprintEvent
    seo: custom_seo {
      title
      description
      image {
        ...Asset
      }
      site {
        handle
        direction
        lang
        locale
        name
        permalink
        short_locale
        url
      }
      alternate_locales {
        url
        site {
          direction
          handle
          lang
          locale
          name
          permalink
          short_locale
          url
        }
      }
      canonical_url
      change_frequency
      compiled_title
      home_url
      humans_txt
      next_url
      og_title
      prev_url
      priority
      site_name
      site_name_position
      site_name_separator
      twitter_card
      twitter_handle
      is_og_glide_enabled
      is_twitter_glide_enabled
      robots {
        value
      }
      google_verification
      bing_verification
    }
  }
}
    ${BlueprintPageFragmentDoc}
${AssetFragmentDoc}
${ContentElementsFragmentDoc}
${DocumentFragmentDoc}
${BlueprintNewsFragmentDoc}
${BlueprintJobFragmentDoc}
${BlueprintEventFragmentDoc}`;
export const EntryHeroDocument = gql`
    query EntryHero($uri: String, $site: String) {
  entry(uri: $uri, site: $site) {
    url
    id
    title
    slug
    ... on Entry_Pages_Page {
      headline
      lead
      illustration {
        ...Asset
      }
      hero_link
      hero_link_text
    }
  }
}
    ${AssetFragmentDoc}`;
export const EventsDocument = gql`
    query Events($sort: String = "created_at desc", $page: Int = 1, $limit: Int = 6, $filter: JsonArgument) {
  entries(
    collection: "events"
    sort: [$sort]
    page: $page
    limit: $limit
    filter: $filter
  ) {
    current_page
    last_page
    total
    per_page
    data {
      ...BlueprintEvent
    }
  }
}
    ${BlueprintEventFragmentDoc}
${AssetFragmentDoc}`;
export const EventsAndTermsDocument = gql`
    query EventsAndTerms($sort: String = "created_at desc", $page: Int = 1, $limit: Int = 6, $filter: JsonArgument, $filterLocale: JsonArgument) {
  entries(
    collection: "events"
    sort: [$sort]
    page: $page
    limit: $limit
    filter: $filter
  ) {
    current_page
    last_page
    total
    per_page
    data {
      ...BlueprintEvent
    }
  }
  event_types: terms(
    taxonomy: "event_types"
    sort: "index asc"
    filter: $filterLocale
  ) {
    data {
      id
      slug
      title
    }
  }
  event_organizers: activeEventOrganizers(
    sort: "title asc"
    filter: $filterLocale
  ) {
    ... on Term_EventOrganizers_EventOrganizer {
      id
      slug
      title
    }
  }
}
    ${BlueprintEventFragmentDoc}
${AssetFragmentDoc}`;
export const JobsDocument = gql`
    query Jobs($sort: String = "created_at desc", $page: Int = 1, $limit: Int = 6, $filter: JsonArgument) {
  entries(
    collection: "jobs"
    sort: [$sort]
    page: $page
    limit: $limit
    filter: $filter
  ) {
    current_page
    last_page
    total
    per_page
    data {
      ...BlueprintJob
    }
  }
}
    ${BlueprintJobFragmentDoc}
${AssetFragmentDoc}`;
export const JobsAndTermsDocument = gql`
    query JobsAndTerms($sort: String = "created_at desc", $page: Int = 1, $limit: Int = 6, $filter: JsonArgument, $filterLocale: JsonArgument) {
  entries(
    collection: "jobs"
    sort: [$sort]
    page: $page
    limit: $limit
    filter: $filter
  ) {
    current_page
    last_page
    total
    per_page
    data {
      ...BlueprintJob
    }
  }
  terms(taxonomy: "professional_fields", sort: "index asc", filter: $filterLocale) {
    data {
      id
      slug
      title
    }
  }
}
    ${BlueprintJobFragmentDoc}
${AssetFragmentDoc}`;
export const NavigationAndGlobalsDocument = gql`
    query NavigationAndGlobals($site: String) {
  nav(handle: "main_nav") {
    title
    tree(site: $site) {
      page {
        id
        title
        url
      }
      children {
        page {
          id
          title
          url
        }
      }
    }
  }
  home_buttons: globalSet(handle: "home_buttons", site: $site) {
    ... on GlobalSet_HomeButtons {
      handle
      entries {
        title
        url
        slug
      }
    }
  }
  header_content: globalSet(handle: "header_content", site: $site) {
    ... on GlobalSet_HeaderContent {
      search
      handle
      logo {
        ...Asset
      }
      about {
        title
        url
        slug
      }
      offersearch {
        url
        slug
        title
      }
    }
  }
  footer_content: globalSet(handle: "footer_content", site: $site) {
    ... on GlobalSet_FooterContent {
      address
      phone
      email
      handle
      logo {
        ...Asset
      }
      privacy {
        id
        url
        title
      }
      imprint {
        id
        url
        title
      }
    }
  }
  translations: globalSet(handle: "translations", site: $site) {
    ... on GlobalSet_Translations {
      handle
      toggle_navigation
      back_link_text
      all_offer_topics
      all_professional_fields
      and_homeoffice
      company_link
      company_name
      job_contact_email
      continue_reading
      description
      description_placeholder
      filter_empty
      from_now
      homeoffice
      is_required
      job_advert_description
      job_advert_published_at
      job_form_button_text
      job_form_contact_subtitle
      job_form_subtitle
      job_form_text
      job_form_title
      job_title
      link
      link_error
      link_is_copied
      link_to_share
      location
      newsletter_button_text
      newsletter_email
      newsletter_success_message
      newsletter_text
      newsletter_title
      pensum
      professional_fields
      professional_fields_placeholder
      published_at
      shared_content
      social_media_links_title
      start
      start_from_now
      start_error
      time_start_error
      job_success_message
      submit_error
      to_home
      to_job_advert
      to_main_content
      to_main_navigation
      to_page_ending
      logo_overlay {
        ...Asset
      }
      whole_amount
      event_title
      event_description
      event_type
      event_link
      event_image
      event_location
      event_date
      event_time
      event_time_until
      event_all_types
      event_online
      event_organizer
      event_info_and_registration
      event_form_title
      event_form_text
      event_form_subtitle
      event_form_contact_subtitle
      event_form_contact_subtitle
      event_form_button_text
      event_contact_email
      event_upload_image_button
      event_success_message
      hrs
      you_might_also_be_interested_in
    }
  }
  forms: globalSet(handle: "forms", site: $site) {
    ... on GlobalSet_Forms {
      job_setup {
        fields {
          config
          display
          handle
          instructions
          type
          width
        }
        handle
        honeypot
        rules
        title
      }
      newsletter {
        fields {
          config
          display
          handle
          instructions
          type
          width
        }
        handle
        honeypot
        rules
        title
      }
      event_setup {
        fields {
          config
          display
          handle
          instructions
          type
          width
        }
        handle
        honeypot
        rules
        title
      }
    }
  }
  offer_selection: globalSet(handle: "offer_selection", site: $site) {
    ... on GlobalSet_OfferSelection {
      heading
      subtitle
      question_1
      question_2
      question_3
      contact_person
      discover_more
      filter
      handle
      key_data
      overlay
      result_singular
      results
      partner_dropdown
      site {
        handle
        locale
        name
        short_locale
        url
      }
    }
  }
  error_404: globalSet(handle: "404_content", site: $site) {
    ... on GlobalSet_404Content {
      text
      back_to_home
      title
    }
  }
  error_500: globalSet(handle: "500_content", site: $site) {
    ... on GlobalSet_500Content {
      text
      back_to_home
      title
    }
  }
  error_503: globalSet(handle: "503_content", site: $site) {
    ... on GlobalSet_503Content {
      text
      title
    }
  }
}
    ${AssetFragmentDoc}`;
export const NewsArticlesDocument = gql`
    query NewsArticles($sort: String = "published_at desc", $page: Int = 1, $limit: Int = 6, $filter: JsonArgument) {
  entries(
    collection: "news"
    sort: [$sort]
    page: $page
    limit: $limit
    filter: $filter
  ) {
    current_page
    last_page
    total
    per_page
    data {
      ... on Entry_News_News {
        id
        slug
        url
        title
        summary
        news_image: image
        image_alt
        content
        published_at
      }
    }
  }
}
    `;
export const NewsArticlesTeaserDocument = gql`
    query NewsArticlesTeaser($filter: JsonArgument) {
  newest: entries(
    collection: "news"
    sort: "published_at desc"
    page: 1
    limit: 1
    filter: $filter
  ) {
    data {
      ... on Entry_News_News {
        id
        slug
        url
        title
        summary
        news_image: image
        image_alt
        content
        published_at
      }
    }
  }
  random: entriesRandom(
    collection: "news"
    sort: "random"
    page: 1
    limit: 1
    filter: $filter
  ) {
    data {
      ... on Entry_News_News {
        id
        slug
        url
        title
        summary
        news_image: image
        image_alt
        content
        published_at
      }
    }
  }
}
    `;
export const OfferTermsDocument = gql`
    query OfferTerms($filter: JsonArgument) {
  company_phases: terms(
    taxonomy: "company_phases"
    sort: "index asc"
    filter: $filter
  ) {
    data {
      id
      slug
      title
      ... on Term_CompanyPhases_CompanyPhases {
        icon {
          ...Asset
        }
      }
    }
  }
  offer_topics: terms(
    taxonomy: "offer_topics"
    sort: "index asc"
    filter: $filter
  ) {
    data {
      id
      slug
      title
    }
  }
  offer_language: terms(
    taxonomy: "offer_language"
    sort: "index asc"
    filter: $filter
  ) {
    data {
      id
      slug
      title
    }
  }
}
    ${AssetFragmentDoc}`;
export const OffersDocument = gql`
    query Offers($sort: String = "created_at desc", $filter: JsonArgument) {
  entries(collection: "offers", sort: [$sort], filter: $filter) {
    current_page
    last_page
    total
    per_page
    data {
      ... on Entry_Offers_Offers {
        id
        email
        contact_person
        contact_person_2
        date
        description
        email_2
        links {
          link
          link_text
        }
        partner_logo {
          ...Asset
        }
        partner {
          ... on Entry_CustomerLogos_CustomerLogo {
            id
            slug
            title
            logo {
              ...Asset
            }
          }
        }
        phone
        phone_2
        short_description
        slug
        title
        kontaktperson
        key_data {
          text
        }
        company_phases {
          title
          url
          id
          slug
          taxonomy {
            title
            handle
          }
        }
        offer_topics {
          slug
          id
          title
        }
        offer_language {
          slug
          id
          title
        }
        offer_topics {
          slug
          id
          title
        }
      }
    }
  }
}
    ${AssetFragmentDoc}`;
export const TermsDocument = gql`
    query Terms($taxonomy: String, $filter: JsonArgument) {
  terms(taxonomy: [$taxonomy], sort: "index asc", filter: $filter) {
    data {
      id
      slug
      title
      ... on Term_CompanyPhases_CompanyPhases {
        icon {
          ...Asset
        }
      }
    }
  }
}
    ${AssetFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CustomerLogos(variables?: CustomerLogosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerLogosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerLogosQuery>(CustomerLogosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerLogos', 'query');
    },
    CustomerLogosAndTerms(variables?: CustomerLogosAndTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerLogosAndTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerLogosAndTermsQuery>(CustomerLogosAndTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerLogosAndTerms', 'query');
    },
    Entry(variables?: EntryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntryQuery>(EntryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Entry', 'query');
    },
    EntryHero(variables?: EntryHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntryHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntryHeroQuery>(EntryHeroDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EntryHero', 'query');
    },
    Events(variables?: EventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventsQuery>(EventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Events', 'query');
    },
    EventsAndTerms(variables?: EventsAndTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EventsAndTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventsAndTermsQuery>(EventsAndTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EventsAndTerms', 'query');
    },
    Jobs(variables?: JobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobsQuery>(JobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Jobs', 'query');
    },
    JobsAndTerms(variables?: JobsAndTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobsAndTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobsAndTermsQuery>(JobsAndTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobsAndTerms', 'query');
    },
    NavigationAndGlobals(variables?: NavigationAndGlobalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NavigationAndGlobalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationAndGlobalsQuery>(NavigationAndGlobalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NavigationAndGlobals', 'query');
    },
    NewsArticles(variables?: NewsArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewsArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewsArticlesQuery>(NewsArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewsArticles', 'query');
    },
    NewsArticlesTeaser(variables?: NewsArticlesTeaserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewsArticlesTeaserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewsArticlesTeaserQuery>(NewsArticlesTeaserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewsArticlesTeaser', 'query');
    },
    OfferTerms(variables?: OfferTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfferTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfferTermsQuery>(OfferTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OfferTerms', 'query');
    },
    Offers(variables?: OffersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffersQuery>(OffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Offers', 'query');
    },
    Terms(variables?: TermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TermsQuery>(TermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Terms', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;